<script setup lang="ts">
import GbButton from '@/components/GbButton.vue'
import { goalbookUrls } from '@/util/links'

const goHome = () => window.location.href = goalbookUrls.toolkitHome
</script>

<template>
  <div class="flex flex-col items-center justify-center h-[50vh] w-full">
    <h1 class="text-[2.5rem] font-medium mb-14">
      This content is only available for Premium users.
    </h1>
    <GbButton gbTheme="bluePrimary" @click="goHome">Back to Toolkit Home</GbButton>
  </div>
</template>
